import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../reducers/aprobaciones";
import * as Api from "../api";
import { toast } from "react-toastify";

function* getCandidatosSaga(action) {
    try {
        const response = yield call(Api.getAprobadoresCandidatos, action.proyectoId);
        const payload = response.data.data || response.data;
        yield put({ type: types.GET_CANDIDATOS_SUCCESS, payload });
    } catch (error) {
        yield put({ type: types.GET_CANDIDATOS_ERROR, error: error.message });
    }
}

function* getSolicitudesSaga(action) {
    try {
        const response = yield call(Api.getSolicitudesAprobacionProyecto, action.proyectoId);
        const payload = response.data.data || response.data;
        yield put({ type: types.GET_SOLICITUDES_SUCCESS, payload });
    } catch (error) {
        yield put({ type: types.GET_SOLICITUDES_ERROR, error: error.message });
    }
}

function* getBloqueoSaga(action) {
    try {
        const response = yield call(Api.getEstadoBloqueoAprobacion, action.proyectoId, action.moduloTipo, action.referenciaId);
        const payload = response.data.data || response.data;
        yield put({
            type: types.GET_BLOQUEO_SUCCESS,
            moduloTipo: action.moduloTipo,
            payload,
        });
    } catch (error) {
        yield put({ type: types.GET_BLOQUEO_ERROR, error: error.message });
    }
}

function* solicitarAprobacionSaga(action) {
    try {
        const response = yield call(Api.postSolicitarAprobacion, action.proyectoId, action.payload);
        yield put({ type: types.SOLICITAR_APROBACION_SUCCESS });
        toast.success("Solicitud de aprobación enviada con éxito. Se notificó a los aprobadores por correo.");

        // Refrescar solicitudes y bloqueo del módulo
        yield put({ type: types.GET_SOLICITUDES_REQUEST, proyectoId: action.proyectoId });
        if (action.payload && action.payload.moduloTipo) {
            yield put({
                type: types.GET_BLOQUEO_REQUEST,
                proyectoId: action.proyectoId,
                moduloTipo: action.payload.moduloTipo,
                referenciaId: action.payload.referenciaId
            });
        }

        if (action.onSuccess) {
            const resData = (response.data && response.data.data) ? response.data.data : null;
            action.onSuccess(resData);
        }
    } catch (error) {
        const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message || "Error al enviar solicitud de aprobación";
        toast.error(errorMsg);
        yield put({ type: types.SOLICITAR_APROBACION_ERROR, error: errorMsg });
    }
}

function* votarAprobacionSaga(action) {
    try {
        const response = yield call(Api.postVotarAprobacion, action.solicitudId, action.payload);
        yield put({ type: types.VOTAR_APROBACION_SUCCESS });

        const voto = action.payload && action.payload.voto;
        if (voto === 'APROBADO') {
            toast.success("Visto bueno registrado correctamente.");
        } else {
            toast.warn("Rechazo registrado. Se notificó por correo a los involucrados.");
        }

        // Refrescar solicitudes
        if (action.proyectoId) {
            yield put({ type: types.GET_SOLICITUDES_REQUEST, proyectoId: action.proyectoId });
        }

        if (action.onSuccess) {
            const resData = (response.data && response.data.data) ? response.data.data : null;
            action.onSuccess(resData);
        }
    } catch (error) {
        const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message || "Error al registrar voto";
        toast.error(errorMsg);
        yield put({ type: types.VOTAR_APROBACION_ERROR, error: errorMsg });
    }
}

export default [
    takeLatest(types.GET_CANDIDATOS_REQUEST, getCandidatosSaga),
    takeLatest(types.GET_SOLICITUDES_REQUEST, getSolicitudesSaga),
    takeLatest(types.GET_BLOQUEO_REQUEST, getBloqueoSaga),
    takeLatest(types.SOLICITAR_APROBACION_REQUEST, solicitarAprobacionSaga),
    takeLatest(types.VOTAR_APROBACION_REQUEST, votarAprobacionSaga),
];
